import React, {Component} from 'react'

const withSubDropdown = ({name}) => WrappedComponent => {
  return class extends Component {
    render() {
      const {data} = this.props
      const list = data[name] || []
      return <WrappedComponent {...this.props} data={list} />
    }
  }
}

export default withSubDropdown
